import React from 'react'

const EventTicker = ({ isVisible = true, repeat = true }) => {
  if (!isVisible) return null

  const today = new Date()
  const dateString = `${today.getDate().toString().padStart(2, '0')}${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}${today.getFullYear().toString().slice(2)}`
  const utmSource = `fffworks-ticker-ws-tomorrow-${dateString}`

  const delimiter = (
    <span
      className='inline-block px-1.5 pt-0 pb-0.5 -mb-0.5 border border-white border-opacity-30 rounded-md group-hover:border-opacity-80 transition-all duration-200 text-sm font-normal tracking-wider mx-4'
      style={{ fontVariant: 'small-caps' }}
    >
      скоро
    </span>
  )

  const text = (
    <>
      <span className='font-bold'>
        Лайфхак-воркшоп «Сделать завтра» 18-19 июня
      </span>{' '}
      — учимся собирать закрытые списки дел и дожимать дни
    </>
  )

  // Repeat text 10 times to ensure smooth endless animation
  const repeatedText = repeat ? (
    <>
      {Array(10)
        .fill(null)
        .map((_, index) => (
          <React.Fragment key={index}>
            {text}
            {index < 9 && delimiter}
          </React.Fragment>
        ))}
    </>
  ) : (
    text
  )

  return (
    <a
      href={`https://fff.works/workshops/tomorrow/?utm_source=${utmSource}`}
      target='_blank'
      rel='noopener noreferrer'
      className='block w-full bg-black pt-1.5 pb-2 overflow-hidden whitespace-nowrap group'
    >
      <div
        className='animate-marquee inline-block text-white opacity-70 group-hover:opacity-100 transition-all duration-200'
        style={{ '--animation-play-state': 'running' }}
        onMouseEnter={(e) =>
          e.currentTarget.style.setProperty('--animation-play-state', 'paused')
        }
        onMouseLeave={(e) =>
          e.currentTarget.style.setProperty('--animation-play-state', 'running')
        }
      >
        {repeatedText}
      </div>
    </a>
  )
}

export default EventTicker
